<template>
  <div>
    <highcharts ref="chart" :options="options" />
    <br />
    <b-table
      :striped="true"
      :narrowed="true"
      :hoverable="true"
      :data="values"
      :columns="columns"
    />
  </div>
</template>

<script>
import '@/plugins/highcharts.js'
import { useCoreStore } from '../../stores/core'

export default {
  name: 'TravelsModesPurposesEmissionsBar',
  props: {
    ghgi: {
      type: Object,
      default: null
    }
  },
  setup () {
    let coreStore = useCoreStore()
    return { coreStore }
  },
  computed: {
    purposes: function () {
      return this.coreStore.travelPurposeLabels
    },
    values: function () {
      let values = []
      let intensities = this.ghgi.emissions.travels.statuspurposes.intensity
      for (let position of Object.keys(intensities)) {
        let allPurposes = {}
        let i = 0
        for (let purpose of this.purposes) {
          allPurposes[this.$t(purpose)] =
            '<nobr>' +
            this.$options.filters.splitNumberTons(
              intensities[position][i].intensity
            )
          allPurposes[this.$t(purpose)] +=
            ' +/- ' +
            this.$options.filters.splitNumberTons(
              intensities[position][i].uncertainty
            ) +
            '</nobr>'
          i += 1
        }
        allPurposes['position'] = '<nobr>' + this.$t(position) + '</nobr>'
        values.push(allPurposes)
      }
      return values
    },
    columns: function () {
      let columns = [
        {
          field: 'position',
          label: this.$t('position'),
          sticky: true
        }
      ]
      for (let purpose of this.purposes) {
        columns.push({
          field: this.$t(purpose),
          label: this.$t(purpose),
          numeric: true
        })
      }
      return columns
    },
    series: function () {
      let series = []
      for (let position of this.coreStore.travelPositionLabels) {
        let e = this.ghgi.emissions.travels.statuspurposes.intensity[position]
        let intensities = e.map((obj) => obj.intensity / 1000)
        let uncertainties = e.map((obj) => {
          return [
            (obj.intensity - obj.uncertainty) / 1000,
            (obj.intensity + obj.uncertainty) / 1000
          ]
        })
        series.push(
          {
            name: this.$t(position),
            data: intensities
          },
          {
            name: this.$t('uncertainty'),
            type: 'errorbar',
            lineWidth: 2,
            data: uncertainties
          }
        )
      }
      return series
    },
    options: function () {
      return {
        chart: {
          type: 'column'
        },
        title: {
          text: ''
        },
        series: this.series,
        xAxis: {
          categories: this.purposes.map((val) => this.$t(val)),
          crosshair: true
        },
        yAxis: {
          min: 0,
          title: {
            text: this.$t('emissions.t.co2e.short')
          }
        },
        tooltip: {
          shared: true,
          valueDecimals: 2,
          valueSuffix: ' ' + this.$t('t.co2e')
        }
      }
    }
  }
}
</script>

<style>
.is-sticky {
  background: #fafafa !important;
}
.table td {
  vertical-align: middle !important;
}
</style>
